import React from "react";
import { CcModal } from "../../design-system/carecentre";
import BookDemoFlow from "./BookDemoFlow";
import { useStyles } from "./style";

const BookDemoModal = ({ open, onClose, moduleName }) => {
  const classes = useStyles();

  return (
    <CcModal
      open={open}
      onClose={onClose}
      title="Book a demo"
      subtitle={
        moduleName
          ? `We’ll show how ${moduleName} fits your care home.`
          : "Pick a time that works for your team."
      }
      maxWidth="sm"
      contentClassName={classes.demoModalBody}
    >
      {open ? (
        <BookDemoFlow
          moduleName={moduleName}
          initialStep={2}
          hideStart
          onCancel={onClose}
        />
      ) : null}
    </CcModal>
  );
};

export default BookDemoModal;
